<template>
  <div class="layer-list">
    <div v-for="item in items" :key="item.id">
      <slot :name="item.id" :item="item">
        <toggle-label v-model="item.enabled">
          {{ item.label || item.id }}
        </toggle-label>
      </slot>
    </div>
  </div>
</template>

<script>
import ToggleLabel from './toggle-label.vue'

export default {
  components: { ToggleLabel },
  props: {
    items: {
      type: Array,
      default: () => [
        { id: 'layer-1', enabled: false },
        { id: 'layer-2', enabled: false }
      ]
    }
  }
}
</script>

<style lang="scss" scoped></style>
